// extracted by mini-css-extract-plugin
export var cardContainer = "relatedContent-module--cardContainer--0686c";
export var cardContainerWrapper = "relatedContent-module--cardContainerWrapper--1051e";
export var dark = "relatedContent-module--dark--a30f7";
export var headline = "relatedContent-module--headline--48852";
export var light = "relatedContent-module--light--7d22c";
export var relatedContent = "relatedContent-module--relatedContent--383a3";
export var relatedContentGrid = "relatedContent-module--relatedContentGrid--6dd57";